import { ReactNode } from 'react'

const AssetIcon = ({
  children,
  borderColor = 'border-primary',
  size = 'w-14 h-14'
}: {
  children: ReactNode
  borderColor?: string
  size?: string
}) => {
  return (
    <div
      className={`rounded-full ${size} border-2 ${borderColor} justify-items-center content-center bg-secondary/10`}
    >
      {children}
    </div>
  )
}

export default AssetIcon
